import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { GridApi, GridApiImpl } from '@/infrastructure/api-functions/grid-api';
import { GridModel, GridModelImpl } from '@/services/grid-model';
import { GridService, GridServiceImpl } from '@/services/grid-service';

export const gridModule = new ContainerModule((bind) => {
    bind(GridApi).to(GridApiImpl);
    bind(GridModel).to(GridModelImpl);
    bind(GridService).to(GridServiceImpl);
});
